import { render, staticRenderFns } from "./PkgOrderPreview.vue?vue&type=template&id=a81e0d60&scoped=true"
import script from "./PkgOrderPreview.vue?vue&type=script&lang=js"
export * from "./PkgOrderPreview.vue?vue&type=script&lang=js"
import style0 from "./PkgOrderPreview.vue?vue&type=style&index=0&id=a81e0d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81e0d60",
  null
  
)

export default component.exports